export const ttCode = ``;